<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="用户名称" prop="userName" style="width: 80%">
                <el-input
                  v-model="searchForm.userName"
                  placeholder="请输入用户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号码" prop="phone" style="width: 80%">
                <el-input
                  v-model="searchForm.phone"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
            </el-col>    
            <el-col :span="6" >
              <el-form-item label="工单类型" prop="type" >
                 <el-select

                  v-model="searchForm.type"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in TypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>                     
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px"></div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" align="center">
        </el-table-column>   
        <el-table-column prop="type" label="类型" align="center" :formatter="typeSelect">
        </el-table-column>           
        <el-table-column prop="address" label="地址" align="center">
        </el-table-column>  
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button @click="seeDetail(scope.row)" type="text" size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>                 
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
     <!-- 新增模态框 -->
      <el-dialog
        title="详情"
        :visible.sync="isAddModal"
        width="30%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          label-position="center"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名称" prop="phone">
                <el-input
                  v-model="addData.userName"
                  placeholder="请输入用户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号码" prop="phone">
                <el-input
                  v-model="addData.phone"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
            </el-col>            
          </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="地址" prop="address">
                <el-input
                  v-model="addData.address"
                  placeholder="请输入地址"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型" prop="type">
               <el-select
                  v-model="addData.type"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in TypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>            
          </el-row>   
        <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="address">
                <img :src="item" v-for="(item,ind) in addData.img" :key="ind" alt="" width="100px" height="100px" style="margin-right:15px;">
              </el-form-item>
            </el-col>           
          </el-row>   
       <el-row>
            <el-col :span="24">
              <el-form-item label="内容" prop="address">
                <el-input
                  type="textarea"
                  autosize
                  v-model="addData.address"
                  placeholder="无"
                ></el-input>
              </el-form-item>
            </el-col>           
          </el-row>                           
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isAddModal = false" 
            >确 定</el-button
          >
        </span>
      </el-dialog>        
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
export default {
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading:false,
      isAddModal:false,
      searchForm: {
        userName: "",
        phone:'',
        type:''
      },
      addData:{

      },
      TypeList:[{
        id:1,
        name:'报事'
      },{
        id:2,
        name:'报修'
      }],
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    seeDetail(row){
        this.addData = row
        this.isAddModal = true
    },
    typeSelect(row){
        if(row.type == 1){
            return '报事'
        }else{
            return '报修'
        }    
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad(ind) {
      if(ind == 1){
        this.currentPage = 1
      }
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        ...this.searchForm
      }
      this.$Apis.zlbOderWorkList(data).then(res=>{
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach(item => {
            item.img = item.img && item.img.split(',')
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>